import { publicPaymentService } from "../../services/publicPayment.service";
import paymentType from "./publicPaymentTypes";
import errorHandler from "../../handlers/errorHandler";



/**
 * Show a public payment
 **/

export const showAPublicPayment = (id) => async (dispatch) => {
  try {
    dispatch({ type: paymentType["LOADING_PUBLIC_PAYMENT"], payLoad: true });
    const response = await publicPaymentService.showAPublicPayment(id);
    dispatch({ type: paymentType["LOADING_PUBLIC_PAYMENT"], payLoad: false });
    dispatch({ type: paymentType["SINGLE_PUBLIC_PAYMENT"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: paymentType["LOADING_PUBLIC_PAYMENT"], payLoad: false });
    errorHandler(error, true);
  }
};

